export default function swiper() {
  const jsMvSwiper = document.getElementById('js-mv-swiper');
  if (jsMvSwiper) {
    new Swiper(jsMvSwiper, {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      speed: 2000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.72,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      lazy: {
        loadPrevNext: true,
      }
    });
  }

  const jsBannerSwiper = document.getElementById('js-banner-swiper');
  if (jsBannerSwiper) {
    let bannerSwiper = null;
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const initSwiper = () => {
      new Swiper(jsBannerSwiper, {
        loop: true,
        autoplay: false,
        speed: 1000,
        slidesPerView: 1,
        initialSlide: 1,
        centeredSlides: true,
        pagination: {
          el: '#banner-pagination',
          clickable: true,
        },
      });
    }
    const checkBreakpoint = (e) => {
      if (e.matches) {
        jsBannerSwiper.classList.add('swiper-initialized');
        initSwiper();
      } else {
        // メディアクエリにマッチせず、スライダーが初期化済みだったらスライダーを解除
        jsBannerSwiper.classList.remove('swiper-initialized');
        if (bannerSwiper) bannerSwiper.destroy(false, true);
      }
    }
    mediaQuery.addEventListener('change', checkBreakpoint); // ブレークポイント通過時に実行
    checkBreakpoint(mediaQuery); // ロード時に初回実行
  }

  const jsWorkSwiper = document.getElementById('js-work-swiper');
  if (jsWorkSwiper) {
    new Swiper(jsWorkSwiper, {
      slidesPerView: 1.4,
      loop: true,
      spaceBetween: 20,
      centeredSlides: true,
      speed: 1000,
      breakpoints: {
        768: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.4,
          spaceBetween: 40,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
}
